import { Component, Element, h, Host, Prop, State, Watch } from "@stencil/core";
import { getSize } from "../utils/utils";
import icons from "../icons";
export class Icon {
  constructor() {
    this.version = '1.9.0';
    /**
     *  when multiple symbols are given, defines the way the transition between the given symbols
     */
    this.trigger = "hover";
    /**
     *  number in milliseconds of the duration of animation or transition
     */
    this.duration = 200;
    /**
     *  should the symbols be morphed from one to another?
     */
    this.morph = false;
    // annimation state - TBD
    this.state = "forward";
  }
  /*
    get the mapped SVG's if there are any
  */
  getSVGs() {
    let symbols = this.name ?
      (this.name.indexOf(",") === -1 ? [this.name] : this.name.split(","))
      : false;
    if (!symbols || symbols.length === 0) {
      console.warn('no symbols given. Please specify as text content like <c-icon name="plus"></c-icon>');
      return;
    }
    this.svgs = symbols.map(symbolName => icons[symbolName]);
  }
  initListeners() {
    const that = this;
    const update = evt => {
      that.updateSVGStyles();
      if (evt.type === ("focus" || "blur") && this.animation) {
        this.animation.play();
      }
    };
    this.el.parentNode.addEventListener("mouseover", update);
    this.el.parentNode.addEventListener("mouseout", update);
    this.el.parentNode.addEventListener("focus", update);
    this.el.parentNode.addEventListener("blur", update);
  }
  async updateSVGStyles() {
    let size;
    if (!this.size) {
      size = getSize(this.el);
      if (size === "auto" && !this.updated) {
        setTimeout(() => {
          this.updateSVGStyles();
          this.updated = true;
        }, 30);
      }
      else {
        this.size = size;
      }
    }
    this.style = `
    span {
      display: flex;
      height: ${this.size};
      width: ${this.size};
      line-height: ${this.size};
    }

    svg {
      width: ${this.size};
    }
    svg circle {
      stroke: currentColor;
    }
    svg:not(.preserve-svg-colors) path {
      fill: currentColor;
    }`;
    if (this.animation)
      this.animation.updateStyles(this.style);
  }
  componentWillLoad() {
    this.initListeners();
    // CSP Adjustments
    const metaNonce = document.querySelector("meta[property='csp-nonce']");
    this.nonce = metaNonce ? metaNonce.content : "__NONCE__";
    this.updateSVGStyles();
    this.getSVGs();
  }
  componentDidLoad() {
    // initially get Styles from this or the parent component
    // this.updateSVGStyles();
  }
  render() {
    return (h(Host, null,
      h("style", { nonce: this.nonce }, `:host ${this.style}; `),
      this.svgs && this.style && (h("span", null,
        this.morph && (h("c-animate", { svgs: this.svgs, ref: el => (this.animation = el), styles: this.style })),
        !this.morph && h("span", { class: "icon", innerHTML: this.svgs[0] })))));
  }
  static get is() { return "c-icon"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["c-icon.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["c-icon.css"]
  }; }
  static get properties() { return {
    "name": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "name",
      "reflect": true
    },
    "myname": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "myname",
      "reflect": true
    },
    "version": {
      "type": "string",
      "mutable": true,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "version",
      "reflect": true,
      "defaultValue": "'1.9.0'"
    },
    "trigger": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "\"hover\" | \"focus\"",
        "resolved": "\"focus\" | \"hover\"",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "when multiple symbols are given, defines the way the transition between the given symbols"
      },
      "attribute": "trigger",
      "reflect": false,
      "defaultValue": "\"hover\""
    },
    "duration": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "number in milliseconds of the duration of animation or transition"
      },
      "attribute": "duration",
      "reflect": false,
      "defaultValue": "200"
    },
    "morph": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "should the symbols be morphed from one to another?"
      },
      "attribute": "morph",
      "reflect": false,
      "defaultValue": "false"
    }
  }; }
  static get states() { return {
    "style": {},
    "state": {},
    "svgs": {}
  }; }
  static get elementRef() { return "el"; }
  static get watchers() { return [{
      "propName": "name",
      "methodName": "getSVGs"
    }]; }
}
